var _global = (typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {}); _global.SENTRY_RELEASE={id:"4e4cb0039126ee8f9f0ac9febb302df1f54c4877"};
      _global.SENTRY_RELEASES=_global.SENTRY_RELEASES || {};
      _global.SENTRY_RELEASES["prebuilt-ui@pluot-communications"]={id:"4e4cb0039126ee8f9f0ac9febb302df1f54c4877"};
      